export default {
  items: [
    {
      name: 'ড্যাশবোর্ড',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },
    // {
    //   name: 'সেটিংস্‌',
    //   url: '/holding-list',
    //   icon: 'fa fa-money',
    //   children: [
    //     {
    //       name: 'রাস্তার লিস্ট',
    //       url: '/road-list',
    //       icon: 'fa fa-object-ungroup'
    //     },
    //     {
    //       name:'অন্যান্য লিজ',
    //       url:'/other-lease',
    //       icon:'fa fa-object-ungroup'
    //     }
    //   ]
    // },
    {
      name: 'ইউজার ম্যানেজার',
      url: '/user-group',
      icon: 'fa fa-money',
      children: [
        {
          name: 'ইউজার গ্রুপ',
          url: '/user-group',
          icon: 'icon-star'
        },
        {
          name: 'ইউজার লিস্ট',
          url: '/user-list',
          icon: 'icon-star'
        },
      ]
    },
    {
      name: 'হোল্ডিং নিবন্ধন',
      url: '/holding-registration',
      icon: 'fa fa-h-square'
    },

  ],
}
